import { Link } from "@tanstack/react-router";
import { Calendar, Clock, MapPin } from "lucide-react";
import { ResponsiveImage } from "@/components/ResponsiveImage";

export interface EventItem {
  id: string;
  title: string;
  event_date: string;
  event_time: string | null;
  location: string;
  poster_url: string | null;
  description: string | null;
}

export function EventCard({ event }: { event: EventItem }) {
  const date = new Date(event.event_date).toLocaleDateString("en-IN", {
    day: "numeric", month: "long", year: "numeric",
  });
  return (
    <article className="group overflow-hidden rounded-2xl border border-border bg-card shadow-sm transition hover:shadow-xl">
      <Link
        to="/events"
        hash={event.id}
        className="block aspect-[4/5] overflow-hidden bg-secondary"
        aria-label={`View details for ${event.title}`}
      >
        {event.poster_url ? (
          <ResponsiveImage
            src={event.poster_url}
            alt={`${event.title} poster`}
            widths={[320, 480, 640, 800, 1080]}
            sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
            fallbackWidth={640}
            className="h-full w-full object-cover duration-700 group-hover:scale-105"
          />
        ) : (
          <div className="flex h-full items-center justify-center font-script text-3xl text-primary/40">
            Surer Adda
          </div>
        )}
      </Link>
      <div className="space-y-2 p-5">
        <h3 className="text-xl font-semibold text-foreground">{event.title}</h3>
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <Calendar className="h-4 w-4 text-primary" /> {date}
        </div>
        {event.event_time && (
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Clock className="h-4 w-4 text-primary" /> {event.event_time}
          </div>
        )}
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <MapPin className="h-4 w-4 text-primary" /> {event.location}
        </div>
      </div>
    </article>
  );
}
